export const config = {
    ajaxUrl: '/wp-admin/admin-ajax.php',
    nonce: 'vetgeheimenonce',
};

